import  React from 'react';
const TargetContext = React.createContext();
export const TargetConsumer = TargetContext.Consumer;
export default TargetContext;